module.exports = __webpack_public_path__ + "img/Artboard3.3b94015b.png";